import { Banner, type BannerProps } from "#ui/banner";
import { Container } from "#ui/container";
import { H1 } from "#ui/typography";

export function BannerWithTitleOnly({
  title,
  ...props
}: Omit<BannerProps, "children" | "title"> & { title: string }) {
  return (
    <Banner {...props}>
      <Container>
        <H1 size="h2">{title}</H1>
      </Container>
    </Banner>
  );
}
